<div class="risks-section">
    <!-- Section Header -->
    <div class="risks-header">
        <div class="header-title">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>{{'risks'|translate}}</span>
        </div>
        <div class="header-actions">
            <div class="search-wrapper">
                <i class="fa-solid fa-search search-icon"></i>
                <input type="text" 
                       pInputText 
                       [(ngModel)]="riskSearchTerm" 
                       class="modern-search"
                       placeholder="{{'search_by_risk_name'|translate}}" />
            </div>
            <div *ngIf="'manage_risk' | able: 'Project' :user:project">
                <p-button (onClick)="openCreatedRiskModal()" 
                          label="{{'new_risk'|translate}}" 
                          [outlined]="true">
                </p-button>
            </div>
        </div>
    </div>

    <!-- Risks Cards Grid -->
    <div class="risks-grid" (click)="closeAllMenus()">
        @for(risk of filteredRisks; track risk.id; let i = $index){
        <article class="risk-card" [style.animation-delay]="(i * 0.1) + 's'">
            
            <!-- 3-Dot Menu (Top Left) -->
            <div class="risk-menu-container" (click)="$event.stopPropagation()" 
                 *ngIf="'manage_risk' | able: 'Project' :user:project">
                @if(activeMenuId === risk.id) {
                <div class="menu-dropdown" (click)="$event.stopPropagation()">
                    <button class="menu-item menu-edit" (click)="openUpdatRiskModal(risk.id); closeMenu()">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <span>{{'edit'|translate}}</span>
                    </button>
                    <button class="menu-item menu-delete" (click)="confirmRiskDelete($event, risk.id); closeMenu()">
                        <i class="fa-regular fa-trash-can"></i>
                        <span>{{'delete'|translate}}</span>
                    </button>
                </div>
                }
                <button class="menu-dots-btn" (click)="toggleMenu($event, risk.id)">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                </button>
            </div>
            
            <!-- Risk Header -->
            <div class="risk-header">
                <div class="risk-name">
                    <i class="fa-solid fa-exclamation-circle"></i>
                    {{risk.name}}
                </div>
            </div>
            
            <!-- Risk Body -->
            <div class="risk-body">
                <!-- Risk Type -->
                <div class="risk-info-item">
                    <i class="fa-solid fa-tag info-icon"></i>
                    <div class="info-content">
                        <span class="info-label">{{'risk_type'|translate}}</span>
                        <span class="info-value">{{risk.type_name}}</span>
                    </div>
                </div>
                
                <!-- Risk Weight -->
                <div class="risk-info-item">
                    <i class="fa-solid fa-weight-hanging info-icon"></i>
                    <div class="info-content">
                        <span class="info-label">{{'risk_weight'|translate}}</span>
                        <div class="risk-weight-badge" [style.background-color]="getWeightColor(risk.weight || 0)">
                            {{risk.weight || 0}}/25
                        </div>
                    </div>
                </div>
                
                <!-- Description -->
                <div class="risk-info-item full-width">
                    <i class="fa-solid fa-align-left info-icon"></i>
                    <div class="info-content">
                        <span class="info-label">{{'description'|translate}}</span>
                        <span class="info-value">{{risk.description}}</span>
                    </div>
                </div>
                
                <!-- Likelihood & Impact -->
                <div class="risk-info-item">
                    <i class="fa-solid fa-chart-simple info-icon"></i>
                    <div class="info-content">
                        <span class="info-label">{{'likelihood'|translate}} × {{'impact'|translate}}</span>
                        <span class="info-value">{{risk.likelihood_name}} × {{risk.impact_name}}</span>
                    </div>
                </div>
                
                <!-- Preventive Action -->
                <div class="risk-info-item full-width">
                    <i class="fa-solid fa-shield-halved info-icon"></i>
                    <div class="info-content">
                        <span class="info-label">{{'preventive_action'|translate}}</span>
                        <span class="info-value">{{risk.action}}</span>
                    </div>
                </div>
                
                <!-- Responsible Person -->
                <div class="risk-info-item">
                    <i class="fa-solid fa-user-tie info-icon"></i>
                    <div class="info-content">
                        <span class="info-label">{{'reponsible_risk'|translate}}</span>
                        <span class="info-value">{{risk.in_charge_name}}</span>
                    </div>
                </div>
                
                <!-- Dates -->
                <div class="risk-dates">
                    <div class="date-item">
                        <i class="fa-solid fa-calendar-plus"></i>
                        <div class="date-content">
                            <span class="date-label">{{'risk_identification_date'|translate}}</span>
                            <span class="date-value">{{risk.risk_identification_date|date:'dd/MM/yyyy'}}</span>
                        </div>
                    </div>
                    
                    <div class="date-arrow">
                        @if(dir === 'rtl') {
                            <i class="fa-solid fa-arrow-left"></i>
                        }@else {
                            <i class="fa-solid fa-arrow-right"></i>
                        }
                    </div>
                    
                    <div class="date-item">
                        <i class="fa-solid fa-calendar-check"></i>
                        <div class="date-content">
                            <span class="date-label">{{'expected_risk_closure_date'|translate}}</span>
                            <span class="date-value">{{risk.expected_risk_closure_date|date:'dd/MM/yyyy'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </article>
        }
        
        <!-- Empty State -->
        @if(filteredRisks.length === 0) {
        <div class="col-12">
            <div class="empty-state">
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M60 110C87.6142 110 110 87.6142 110 60C110 32.3858 87.6142 10 60 10C32.3858 10 10 32.3858 10 60C10 87.6142 32.3858 110 60 110Z" fill="#C91F3B" fill-opacity="0.1"/>
                    <path d="M60 35L50 55H70L60 85L70 65H50L60 35Z" fill="#C91F3B" fill-opacity="0.3" stroke="#C91F3B" stroke-width="3"/>
                    <circle cx="60" cy="60" r="35" stroke="#C91F3B" stroke-width="3" fill="none"/>
                </svg>
                <h3>{{'no_risks_found' | translate}}</h3>
                <p>{{'define_related_risks' | translate}}</p>
            </div>
        </div>
        }
    </div>
</div>

<!-- Add/Edit Risk Modal -->
@if(isVisiblRiskModal)
{
<div class="modal-wrapper">
    <div class="g-overlay" (click)="isVisiblRiskModal=false"></div>
    <div class="g-modal">
        <div class="modal-header">
            <div class="modal-title">
                {{selectedRisk.id?('edit_risk'|translate):('new_risk'|translate)}}
            </div>
            <button class="close-btn" (click)="isVisiblRiskModal=false">
                <i class="fa-solid fa-xmark"></i>
            </button>
        </div>
        
        <div class="modal-body">
            <form #RiskForm="ngForm" (ngSubmit)="submitRisk()">
                <div class="form-grid">
                    <!-- Risk Name -->
                    <div class="form-control full-width">
                        <label class="form-label">
                            <i class="fa-solid fa-exclamation-circle"></i>
                            {{'risk'|translate}}
                        </label>
                        <input type="text" 
                               pInputText 
                               #name="ngModel" 
                               name="name" 
                               [(ngModel)]="selectedRisk.name"
                               required
                               placeholder="{{'enter_risk_name'|translate}}" />
                        @if((name.invalid && !name.pristine)||(isRiskModalSubmitted&&name.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                    
                    <!-- Risk Type -->
                    <div class="form-control">
                        <label class="form-label">
                            <i class="fa-solid fa-tag"></i>
                            {{'risk_type'|translate}}
                        </label>
                        <p-dropdown #riskTypes="ngModel" 
                                    [options]="ProjectsRelations.riskTypes" 
                                    [(ngModel)]="selectedRisk.type"
                                    name="type" 
                                    required 
                                    optionLabel="name_ar" 
                                    optionValue="name_en"
                                    placeholder="{{'select_risk_type'|translate}}">
                        </p-dropdown>
                        @if((riskTypes.invalid && !riskTypes.pristine)||(isRiskModalSubmitted&&riskTypes.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                    
                    <!-- Responsible Person -->
                    <div class="form-control">
                        <label class="form-label">
                            <i class="fa-solid fa-user-tie"></i>
                            {{'responsible_for_preventive_measure'|translate}}
                        </label>
                        <input type="text" 
                               pInputText 
                               #in_charge_name="ngModel"
                               [(ngModel)]="selectedRisk.in_charge_name" 
                               name="in_charge_name"
                               required
                               placeholder="{{'responsible_for_preventive_measure'|translate}}" />
                        @if((in_charge_name.invalid && !in_charge_name.pristine)||(isRiskModalSubmitted&&in_charge_name.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                    
                    <!-- Description -->
                    <div class="form-control full-width">
                        <label class="form-label">
                            <i class="fa-solid fa-align-left"></i>
                            {{'description'|translate}}
                        </label>
                        <textarea pInputTextarea 
                                  #description="ngModel"
                                  name="description" 
                                  [(ngModel)]="selectedRisk.description"
                                  required
                                  rows="3"
                                  placeholder="{{'enter_description'|translate}}">
                        </textarea>
                        @if((description.invalid && !description.pristine)||(isRiskModalSubmitted&&description.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                    
                    <!-- Likelihood -->
                    <div class="form-control">
                        <label class="form-label">
                            <i class="fa-solid fa-percentage"></i>
                            {{'likelihood'|translate}}
                        </label>
                        <p-dropdown #likelihood="ngModel"
                                    [options]="ProjectsRelations.levels" 
                                    name="likelihood"
                                    [(ngModel)]="selectedRisk.likelihood"
                                    (onChange)="calcWeight()"
                                    required 
                                    optionLabel="name_ar" 
                                    optionValue="name_en"
                                    placeholder="{{'select_likelihood'|translate}}">
                        </p-dropdown>
                        @if((likelihood.invalid && !likelihood.pristine)||(isRiskModalSubmitted&&likelihood.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                    
                    <!-- Impact -->
                    <div class="form-control">
                        <label class="form-label">
                            <i class="fa-solid fa-burst"></i>
                            {{'impact'|translate}}
                        </label>
                        <p-dropdown #impact="ngModel"
                                    [options]="ProjectsRelations.levels" 
                                    name="impact"
                                    [(ngModel)]="selectedRisk.impact"
                                    (onChange)="calcWeight()"
                                    required 
                                    optionLabel="name_ar" 
                                    optionValue="name_en"
                                    placeholder="{{'select_impact'|translate}}">
                        </p-dropdown>
                        @if((impact.invalid && !impact.pristine)||(isRiskModalSubmitted&&impact.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                    
                    <!-- Risk Weight (readonly) -->
                    <div class="form-control">
                        <label class="form-label">
                            <i class="fa-solid fa-weight-hanging"></i>
                            {{'risk_weight'|translate}}
                        </label>
                        <input type="text" 
                               pInputText 
                               name="weight"
                               [(ngModel)]="selectedRisk.weight"
                               readonly 
                               disabled
                               class="weight-input" />
                    </div>
                    
                    <!-- Preventive Measures -->
                    <div class="form-control full-width">
                        <label class="form-label">
                            <i class="fa-solid fa-shield"></i>
                            {{'preventive_measures'|translate}}
                        </label>
                        <textarea pInputTextarea 
                                  #action="ngModel"
                                  name="action" 
                                  [(ngModel)]="selectedRisk.action"
                                  required
                                  rows="3"
                                  placeholder="{{'enter_preventive_measures'|translate}}">
                        </textarea>
                        @if((action.invalid && !action.pristine)||(isRiskModalSubmitted&&action.invalid)){
                        <small class="error-message">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'field_is_required'|translate}}
                        </small>
                        }
                    </div>
                </div>
                
                <!-- Date Range Form -->
                <form #dateForm="ngForm" appDateRangeValidator
                      [dateRange]="{ startDate: 'risk_identification_date', endDate: 'expected_risk_closure_date'}">
                    <div class="form-grid mt-3">
                        <!-- Identification Date -->
                        <div class="form-control">
                            <label class="form-label">
                                <i class="fa-solid fa-calendar-plus"></i>
                                {{'risk_identification_date' | translate }}
                            </label>
                            <p-calendar appendTo="body"
                                        [(ngModel)]="selectedRisk.risk_identification_date"
                                        #risk_identification_date="ngModel" 
                                        name="risk_identification_date" 
                                        [iconDisplay]="'input'"
                                        [showIcon]="true"
                                        [dateFormat]="'dd/mm/yy'"
                                        required
                                        inputId="risk_identification_date_input">
                            </p-calendar>
                            @if((risk_identification_date.invalid && !risk_identification_date.pristine)||(isRiskModalSubmitted&&risk_identification_date.invalid)){
                            <small class="error-message">
                                <i class="fa-solid fa-circle-exclamation"></i>
                                {{'field_is_required'|translate}}
                            </small>
                            }
                        </div>

                        <!-- Expected Closure Date -->
                        <div class="form-control">
                            <label class="form-label">
                                <i class="fa-solid fa-calendar-check"></i>
                                {{'expected_risk_closure_date' | translate }}
                            </label>
                            <p-calendar appendTo="body"
                                        [(ngModel)]="selectedRisk.expected_risk_closure_date"
                                        #expected_risk_closure_date="ngModel" 
                                        name="expected_risk_closure_date"
                                        [iconDisplay]="'input'" 
                                        [showIcon]="true"
                                        [dateFormat]="'dd/mm/yy'"
                                        required
                                        inputId="expected_risk_closure_date_input">
                            </p-calendar>
                            @if((expected_risk_closure_date.invalid && !expected_risk_closure_date.pristine)||(isRiskModalSubmitted&&expected_risk_closure_date.invalid)){
                            <small class="error-message">
                                <i class="fa-solid fa-circle-exclamation"></i>
                                {{'field_is_required'|translate}}
                            </small>
                            }
                        </div>
                    </div>
                    
                    @if(dateForm.errors?.['dateRangeInvalid']){
                    <div class="date-error-message">
                        <i class="fa-solid fa-circle-exclamation"></i>
                        {{'risk_identification_date_must_precede_expected_risk_closure_date' | translate}}
                    </div>
                    }
                </form>
            </form>
        </div>
        
        <div class="modal-footer">
            <button type="button" class="cancel-btn" (click)="isVisiblRiskModal=false">
                <i class="fa-solid fa-xmark"></i>
                {{'cancel' | translate}}
            </button>
            <button type="submit" class="save-btn" (click)="submitRisk()">
                <i class="fa-solid fa-check"></i>
                {{'save' | translate}}
            </button>
        </div>
    </div>
</div>
}

<p-confirmPopup #confirmPopupRef>
    <ng-template pTemplate="headless" let-message>
        <div class="confirm-popup-content">
            <div class="confirm-icon">
                <i class="fa-solid fa-triangle-exclamation"></i>
            </div>
            <p class="confirm-message">{{ message.message }}</p>
            <div class="confirm-actions">
                <p-button (click)="accept()" label="{{'yes'|translate}}" severity="danger"></p-button>
                <p-button (click)="reject()" label="{{'no'|translate}}" severity="secondary"></p-button>
            </div>
        </div>
    </ng-template>
</p-confirmPopup>
